import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import config from '../../config';
import httpservice from 'services/httpservice';
import { NotificationManager } from 'components/common/react-notifications';

export const getMerchantsData = createAsyncThunk('merchants/getMerchantsData', async (requestBody, { rejectWithValue }) => {
    try {
        const url = config.url.transaction + config.endpoint.fbl.getMerchantDetails;
        const response = await httpservice.post(url, requestBody);
        const responseData = response?.data;
        if (responseData.responseCode === '00') {
            return responseData.data;
        } else {
            NotificationManager.error(responseData?.responseDescription || "Something went wrong", "ERROR");
            return rejectWithValue(responseData.responseDescription);
        }
    } catch (error) {
        NotificationManager.error("Something went wrong", "ERROR");
        return rejectWithValue(error.message);
    }
});

export const generateQr = createAsyncThunk('merchants/generateQr', async ({ requestBody }, { rejectWithValue }) => {
    try {
        const url = config.url.qr + config.endpoint.fbl.sqrcGenerateQr;
        const response = await httpservice.post(url, requestBody);
        const data = response?.data;
        if (data?.responseCode === '00') {
            return data?.data.qrDtos;
        } else {
            NotificationManager.error(response?.responseDescription || "Something went wrong", "ERROR");
            return rejectWithValue(data?.responseDescription);
        }
    } catch (error) {
        NotificationManager.error("Something went wrong", "ERROR");
        return rejectWithValue(error.message);
    }
});


export const downloadQr = createAsyncThunk('merchants/downloadQr', async ({ requestBody }, { rejectWithValue }) => {
    try {
        const url = config.url.qr + config.endpoint.fbl.sqrcGenerateQr;
        const response = await httpservice.post(url, requestBody, {
            responseType: "blob",
          });
        const data = response?.data
        if (data) {
            const zipBlob = data;

            // Create a URL for the Blob
            const blobUrl = window.URL.createObjectURL(zipBlob);

            // Create an anchor element for downloading
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = 'MerchantQRs.zip';

            // Trigger a click event to start the download
            a.click();

            // Clean up the created URL
            window.URL.revokeObjectURL(blobUrl);
        }
    } catch (error) {
        NotificationManager.error("Something went wrong", "ERROR");
        return rejectWithValue(error.message);
    }
});


const merchantsSlice = createSlice({
    name: 'merchants',
    initialState: {
        loading: false,
        error: null,
        merchantsData: [],
        file:null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMerchantsData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getMerchantsData.fulfilled, (state, action) => {
                state.loading = false;
                state.merchantsData = [action.payload];
            })
            .addCase(getMerchantsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(generateQr.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(generateQr.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(generateQr.fulfilled, (state, action) => {
                // console.log(action.payload);
            
                const qrDtos = action.payload;
            
                const qrMap = qrDtos.reduce((acc, qr) => {
                    if (!acc[qr.mid]) {
                        acc[qr.mid] = [];
                    }
                    acc[qr.mid].push({
                        mid: qr.mid,
                        tid: qr.tid,
                        qrImage: qr.qrImage,
                        logo: qr.logo,
                        merchantName: qr.merchantName,
                        businessAddress: qr.businessAddress
                    });
                    return acc;
                }, {});
            
                state.merchantsData = state.merchantsData.map((merchant) => ({
                    ...merchant,
                    qrCodes: qrMap[merchant.sourceMid] || [],
                }));
            
                state.loading = false;
            }).addCase(downloadQr.pending, (state,action) => {
               state.loading = true 
               state.error = null
            }).addCase(downloadQr.fulfilled, (state,action) => {
                    state.loading = false 
                    state.file = action.payload
                    state.error = null
            }).addCase(downloadQr.rejected, (state,action) => {
                   state.loading = false 
                   state.error = action.payload 
            });
    },
});

export default merchantsSlice.reducer;
